{"debug":false,"testing":false,"baseUrl":"https://apply.se/","apiUrl":"https://apply.se/api/","controlV2Url":"https://control.apply.se"}